import { render, staticRenderFns } from "./FinancialMedal.vue?vue&type=template&id=24f3eeb6&"
import script from "./FinancialMedal.vue?vue&type=script&lang=js&"
export * from "./FinancialMedal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports